import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "volume-controls" }
const _hoisted_2 = { class: "volume-controls__mute-toggle-pulse" }
const _hoisted_3 = { class: "volume-controls__slider-wrapper" }

import { computed } from 'vue'
import MuteIcon from '@/assets/MuteIcon.svg'
import UnmuteIcon from '@/assets/UnmuteIcon.svg'
import useAudioEngine from '@/composables/UseAudioEngine'
import Slider from '@/components/common/Slider.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'VolumeControls',
  setup(__props) {

const { unlockAudioContext, muteAudio, unmuteAudio, volumeGain, setGainValue } = useAudioEngine()
let lastSliderGainValue = volumeGain.value

const onUpdateSliderGain = (value: number): void => {
  setGainValue(value)
  volumeGain.value = value
  muted.value ? muteAudio() : unmuteAudio()
}

const muted = computed(() => {
  return volumeGain.value === 0
})

const updateLastSliderGain = () => {
  if (volumeGain.value !== 0) {
    lastSliderGainValue = volumeGain.value
  }
}

const onToggleMute = () => {
  volumeGain.value = muted.value ? lastSliderGainValue : 0
  setGainValue(volumeGain.value)
  muted.value ? muteAudio() : unmuteAudio()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
      [_vShow, _unref(muted)]
    ]),
    _createElementVNode("div", {
      class: "volume-controls__mute-toggle",
      id: "muteToggle",
      onClick: onToggleMute,
      onClickOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(unlockAudioContext) && _unref(unlockAudioContext)(...args)))
    }, [
      _withDirectives(_createVNode(_unref(MuteIcon), null, null, 512), [
        [_vShow, _unref(muted)]
      ]),
      _withDirectives(_createVNode(_unref(UnmuteIcon), null, null, 512), [
        [_vShow, !_unref(muted)]
      ])
    ], 32),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Slider, {
        min: 0,
        max: 1,
        step: 0.01,
        modelValue: _unref(volumeGain),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => onUpdateSliderGain(value)),
        onChange: _cache[2] || (_cache[2] = ($event: any) => (updateLastSliderGain()))
      }, null, 8, ["step", "modelValue"])
    ])
  ]))
}
}

})